<template>
    <div class="view">
        <div class="d-md-flex justify-content-md-between">
        <Breadcrumb :breadcrumb="breadcrumb" />
        <NextPreviousButtons
            :id="form_data.id"
            :label_key="'name'"
            :label_key_id="'id'"
            :next="next"
            :previous="previous"
            :items="cache_log_productivities"
            :child_href="'/census-log-productivity'"
        />
        </div>
        <h1 class="view__title title--1">
            <span v-html="title_page" />
        </h1>
        <h6 class="view__title title--1" style="font-size: 13px; font-weight: initial; color: gray; margin-top: -10px;" v-if="message">
            <span>
                <img src="/assets/img/svg/information.svg" style="width:15px;" alt="CustomDescription">
            </span>
            <span v-html="message" style="margin-left:5px;"/>
        </h6>
        <div class="col-md-12 p-0">
            <span class="button__modal text-right">
                <a href="#" @click="form_modal()" class="d-inline-md-block">
                    Add notes
                    <i class="prefix ml-1">
                        <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                    </i>
                </a>
            </span>
        </div>
        <div class="detail__content">
            <div class="row mb-0">
                <div class="col-12 col-md-8 py-0">

                    <div class="m-0 formdynamic justify-content-md-between mb-4" style="padding-top:10px;" v-if="(form_data_backup.manually_generated == 0 || form_data_backup.manually_generated == 3) && form_data_backup.associate_id">
                        <FormDynamicV2 :form_format="first_form_format" :form_data="form_data"
                            :array_options="array_options" name="first_form">
                            <template v-slot:col-0>
                                <div class="p-0  col-md-5" style="margin-right: 0px; margin-left: 0px; vertical-align: top;">
                                    <div class="modal__buttons text-left px-4 d-flex" style="margin-top: 19px; gap: 5px;">
                                        <button class="modal__buttons__item px-2" @click="showUnassignedWorkModal()"
                                            style="vertical-align: middle !important; min-width: 160px">
                                            Unassigned work <span class="badge badge-light mt-1" style="min-width: .6rem; font-size: .8rem; color:#495057 ">{{unassigned_work_items.length}}</span>
                                        </button>
                                        <button class="modal__buttons__item px-2" @click="showDischargeBedsModal()"
                                            style="vertical-align: middle !important; min-width: 140px">
                                            Discharges <span class="badge badge-light mt-1" style="min-width: .6rem; font-size: .8rem; color:#495057 ">{{form_data.manually_generated == 3 || form_data.manually_generated == 0 ?  form_data.discharge_beds_count : 0}}</span>
                                        </button>
                                    </div>
                                </div>
                            </template>
                        </FormDynamicV2>
                    </div>

                    <form class="detail__content__formdynamic log-productivty-form" @submit.prevent="live_edition()">
                        <div class=" shadow p-3 mb-5 bg-white rounded">
                            <div class="m-0 formdynamic justify-content-md-between " style="padding-top:10px;">
                                <h2 class="view__title title--1" style="font-size: 18px">
                                    <span v-html="'Census Information'" />
                                </h2>
                                <FormDynamicV2 :form_format="second_form_format" :form_data="form_data"
                                    :array_options="array_options" name="second_form" />
                                <div class="shadow-none p-2 pb-4 bg-light rounded border mb-3 log-productivty-form__third">
                                    <FormDynamicV2 :form_format="third_form_format" :form_data="form_data"
                                        :array_options="array_options" name="third_form" />
                                </div>
                            </div>
                            <center>
                                <h2 class="view__title title--1" style="font-size: 18px">
                                    <span v-html="'Case Cleaning Information'" />
                                </h2>
                            </center>
                            <div class="row">
                                <div class="col-md-8">
                                    <table class="table table-without-border">
                                        <thead class="bg-white">
                                            <tr>
                                                <th scope="col" style="font-size: 15px !important"></th>
                                                <th scope="col" style="font-size: 15px !important">Number of cases</th>
                                                <th scope="col" style="font-size: 15px !important">Total Minutes</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in fourth_form_format" :key="index"
                                                style="line-height: 0.5">
                                                <td v-html="item.name" class="modal-label p-0"
                                                    style="font-size: 15px !important" />
                                                <td v-for="(field, j) in item.fields" :key="j" class="p-1">
                                                    <div>
                                                        <input
                                                            :placeholder="field['placeholder'] !== undefined ? field.placeholder : ''"
                                                            :disabled="field.disabled" :step="field.step"
                                                            :type="field.type" :maxlength="field.maxlength"
                                                            style="max-width: 85%; border-bottom: 1px solid #9e9e9e8c !important;"
                                                            :min="field.type === 'date' && min_date !== undefined ? min_date : field.minlength !== undefined ? field.minlength : ''"
                                                            :max="field.type === 'date' && max_date !== undefined ? max_date : field.maxlength"
                                                            :required="field.required"
                                                            v-model="form_data[field.model_name]" />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row p-3">
                                <div class="p-0 formdynamic__item col-md-7">
                                    <div class="formdynamic__item__field">

                                        <label v-html="'Comments:'" class="modal-label" for="notes" />
                                        <textarea id="notes" class="notes-text-area" :disabled="form_data.manually_generated == 0 || form_data.manually_generated == 2" maxlength="500"
                                            v-model="form_data['notes']" rows="5" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center text-md-right modal__buttons">
                            <a :href="back_href" class="modal__buttons__item cancel" style="margin-right:10px;">
                                Back
                                <svg xmlns="http://www.w3.org/2000/svg" width="10.121" height="6.121"
                                    viewBox="0 0 10.121 6.121">
                                    <g id="down" transform="translate(1.061 1.061)">
                                        <line id="Línea_794" data-name="Línea 794" class="cls-1" x1="4" y1="4" />
                                        <line id="Línea_795" data-name="Línea 795" class="cls-1" y1="4" x2="4"
                                            transform="translate(4)" />
                                    </g>
                                </svg>

                            </a>
                            <button ref="submitButton" class="btn-small-for-views mx-md-0 modal__buttons__item"
                                v-html="'Save changes'" />
                        </div>
                    </form>
                </div>
                <div class="col-12 col-md-4 py-0">
                    <div class="row mb-0 no-gutters">
                        <div class="row mb-0 no-gutters detail__content__notes">
                            <div v-for="(note, i) in notes" :key="i" class="col-12 p-0 card cardModule hoverable">
                                <div class="card-content">
                                    <div class="card-title">
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-10">
                                                <a href="#" @click="modal_update(i)" class="textTitleCard"
                                                    v-html="`${note.title} / ${note.creation_date}`" />
                                            </div>
                                            <div class="col-2 text-right">
                                                <a href="#" @click="modal_deletion(i)">
                                                    <i class="material-icons prefix ">
                                                        <img class="iconCard" src="/assets/img/trash.png" alt="date">
                                                    </i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="mt-3 card-content__text" v-html="note.content" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <WaitingModal />
        <DeletionModal :single_object="single_note" :global_index="global_index"
            @objectDeletion="deletion_filter($event)" />
        <FormModal :title="'New Note'" :breadcrumb="breadcrumb" :parent_id="parent_id" :rest_api="rest_api_note"
        :array_options="array_options" @unshiftObject="unshift_object($event)" />

        <FormModalUnassignedWork 
            :unassigned_work_items="unassigned_work_items"
            :title="'Additional Unassigned Work'" 
            :breadcrumb_modal="breadcrumb"
            :parent_id="parent_id"
            :unassigned_work_headers="unassigned_work_headers"
            @refreshData="refreshData($event)"
        />

        <FormModalDischargeBeds 
            :title="'Discharges'" 
            :breadcrumb_modal="breadcrumb"
            :unassigned_work_headers="unassigned_work_headers"
            :parent_id="parent_id"
            ref="form_modal_discharge_beds"
            @refreshData="refreshData($event)"
        />
        
    </div>
</template>

<script>

import FormResources from './form_resources'
import Resources from './resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal.vue'
import NextPreviousButtons  from  '@/components/NextPreviousButtons.vue'
import FormDynamicV2 from '@/components/FormDynamicV2.vue'
import FormModal from '@/components/DetailComponent/FormModal'
import FormModalUnassignedWork from './FormModalUnassignedWork'
import FormModalDischargeBeds from './FormModalDischargeBeds'
import DeletionModal from '@/components/DeletionModal'
import { Notyf } from 'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
import { emitDischargesForDashboard } from '../../../plugins/socket'
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'LogProductivityDetail',
    components: {
        Breadcrumb,
        WaitingModal,
        FormDynamicV2,
        FormModal,
        DeletionModal,
        FormModalUnassignedWork,
        FormModalDischargeBeds,
        NextPreviousButtons
    },

    data() {
        return {
            notyf,
            parent_id: this.$route.params.id,
            rest_api: `log_productivity/${this.$route.params.id}`,
            lite_rest_api: `log_productivity`,
            rest_api_note: `log_productivity_notes`,
            first_form_format: FormResources.first_form_format,
            second_form_format: FormResources.second_form_format,
            third_form_format: FormResources.third_form_format,
            fourth_form_format: FormResources.fourth_form_format,
            breadcrumb: Resources.breadcrumb,
            title_page: '',
            content_header: this.$store.state.headers,
            form_data_backup: {},
            form_data: {},
            array_options: {},
            back_href: 'census-log-productivity',
            notes: [],
            single_note: {},
            unassigned_work_items: [],
            unassigned_work_headers: [],
            global_index: undefined,
            message: '',
            first_time: false,
            saving_from_associate: false,
            cache_log_productivities: [],
            next: undefined,
            previous: undefined
        }
    },

    watch: 
    {
        async 'form_data.associate_id' (val)
        {
            console.log(this.saving_from_associate);
            if(val && !this.saving_from_associate && this.form_data.associate_id !== this.form_data_backup.associate_id)
            {
                this.saving_from_associate = true
                this.live_edition()
            }
        }
    },

    methods: {

        fill_data(data, afterUpdate = false) 
        {
            this.form_data = data.log_productivity
            this.form_data_backup = {...this.form_data}
            this.cache_log_productivities = data.cache_log_productivities
            this.next = data.next
            this.previous = data.previous

            if(this.form_data.manually_generated == 0 || this.form_data.manually_generated == 3)
            {
                
                this.first_form_format.forEach(item => {
                    if(item.fields && item.fields.length)
                    {
                        item.fields.forEach(field => {
                            field.disabled = true
                        })
                    }
                })

                this.second_form_format.forEach(item => {
                    if(item.fields && item.fields.length)
                    {
                        item.fields.forEach(field => {
                            
                            if(this.form_data.allow_change_associate && field.model_name == 'associate_id')
                            {
                                field.disabled = false
                            }
                            else
                            {
                                field.disabled = true
                            }
                        })
                    }
                })
                
                this.fourth_form_format.forEach(item => {
                    if(item.fields && item.fields.length)
                    {
                        item.fields.forEach(field => {
                            field.disabled = true
                        })
                    }
                })

                this.message = `The productivity log was automatically generated upon completing the assignment, ensuring that all data is accurately calculated and cannot be modified.`
                this.message = `The productivity log was automatically generated upon completing the assignment, ensuring that all data is accurately calculated and cannot be modified.`
            }

            if (!afterUpdate && !this.first_time) 
            {
                this.first_time = true
                this.array_options = {
                    daily_assignment_id: data.assignments,
                    associate_id: data.associates
                }
                this.notes = this.form_data.notes_entities
                this.title_page = `${this.form_data.assignment}`;
                this.breadcrumb[2].arrow = "<span class='slash'>/</span>"
                this.breadcrumb.push({
                    name: this.title_page,
                    href: '#',
                    arrow: " ",
                });
                this.unassigned_work_items = data.unassigned_work_items
                this.unassigned_work_headers = data.unassigned_work_headers
            }
            else 
            {
                this.title_page = `${this.form_data.assignment}`
                this.breadcrumb[3].name = this.title_page;
            }
            setTimeout(() => {
                this.saving_from_associate = false
            }, 500);
        },
        async live_edition() 
        {
            let response = await this.queryGetByMethod(this.rest_api, this.form_data)

            if (response.status) {
                this.fill_data(response.data, true)
                this.$emit('elementsGetter', response.data)
                this.$emit('saveOutside', true)
                notyf.success('Success')
                emitDischargesForDashboard(this.get_user().facility_id)
                return true
            }
            else {
                this.error_handling(response)
                this.saving_from_associate = false
                return false
            }
            
        },

        form_modal() {
            window.$('#static').modal('show')
        },

        unshift_object(new_object) {
            this.notes.unshift(new_object)
        },

        splice_object(splicing_object) {
            this.notes.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        modal_deletion(index) {
            this.global_index = index
            this.single_note = this.notes[index]
            window.$('#static-deletion').modal('show')
        },

        deletion_filter(object) {
            let object_destroyed = {
                id: object.id,
                index: object.index,
                parent_id: this.parent_id,
            }
            this.json_destroyed(this.rest_api_note, object_destroyed)
        },

        trashing(index) {
            this.global_index = undefined
            this.single_note = {}
            this.notes.splice(index, 1)
        },
        showUnassignedWorkModal()
        {
            window.$('#unassigned-work-modal').modal('show')
        },
        showDischargeBedsModal()
        {
            window.$('#discharge-beds-modal').modal('show')
            this.$refs.form_modal_discharge_beds.getData()
        },
        async refreshData()
        {
            await this.api_request()
        }

    },

    async mounted() {
        if (this.hasPermissions(['Census-Log-Productivity Read'])) {
            await this.api_request()
        }
        else {
            window.location = '/'
        }
    },
}
</script>